(function () {
  // ---- Detect your header section handle dynamically ----
  function detectHeaderSectionHandle() {
    // Example match: id="shopify-section-sections--25305573458287__header_section"
    const el =
      document.querySelector('header.shopify-section[id^="shopify-section-sections--"][id$="__header_section"]') ||
      document.querySelector('[id^="shopify-section-sections--"][id$="__header_section"]');
    if (!el || !el.id) return null;
    // Strip the "shopify-section-" prefix to get the handle used by the sections API
    return el.id.replace(/^shopify-section-/, '');
  }

  // Will refresh this one section which contains the cart drawer + bubble
  const HEADER_SECTION_HANDLE = detectHeaderSectionHandle();
  const SECTION_HANDLES = HEADER_SECTION_HANDLE ? [HEADER_SECTION_HANDLE] : [];

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = !!busy;
    btn.classList.toggle('is-busy', !!busy);
  }

  function markPillAdded(pill) {
    if (!pill) return;

    pill.classList.add('is-added');
    pill.classList.remove('is-popping');
    // Force reflow so the animation can restart on repeated taps
    // eslint-disable-next-line no-unused-expressions
    pill.offsetWidth;
    pill.classList.add('is-popping');
    setTimeout(() => pill.classList.remove('is-popping'), 400);
  }

  function toast(msg) {
    let el = document.createElement('div');
    el.className = 'pg-toast';
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(() => el.classList.add('show'));
    setTimeout(() => {
      el.classList.remove('show');
      setTimeout(() => el.remove(), 200);
    }, 1500);
  }

  // Replace a section by handle. Your DOM uses both #shopify-section-<handle> and [data-section-id="<handle>"].
  function replaceSection(handle, html) {
    if (!handle || !html) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    // New section element from response
    let newEl =
      tmp.querySelector(`#shopify-section-${handle}`) ||
      tmp.querySelector(`[data-section-id="${handle}"]`) ||
      tmp.firstElementChild;

    // Current section element in DOM
    let current =
      document.getElementById(`shopify-section-${handle}`) ||
      document.querySelector(`[data-section-id="${handle}"]`) ||
      document.getElementById(handle) || // defensive
      document.querySelector(`.${handle}`); // last-resort fallback

    if (current && newEl) current.replaceWith(newEl);
  }

  async function fetchSections(handles) {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', handles.join(','));
    const res = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Section fetch failed');
    return res.json(); // { "<handle>": "<html>", ... }
  }

    function dispatchCartEvents() {
    ['cart:refresh', 'cart:update', 'ajaxProduct:added'].forEach(name => {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      window.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
  }

  async function addToCart(variantId, qty = 1) {
    const body = new URLSearchParams();
    body.set('id', variantId);
    body.set('quantity', String(qty));

    // Ask add.js to return updated sections if we detected the header handle
    const url = new URL('/cart/add.js', window.location.origin);
    if (SECTION_HANDLES.length) url.searchParams.set('sections', SECTION_HANDLES.join(','));

    const res = await fetch(url.toString(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body,
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  async function refreshFromAddResponse(json) {
    if (json && json.sections && SECTION_HANDLES.length) {
      SECTION_HANDLES.forEach(handle => replaceSection(handle, json.sections[handle]));
      return true;
    }
    return false;
  }

  async function hardRefresh() {
    if (!SECTION_HANDLES.length) return false;
    try {
      const sections = await fetchSections(SECTION_HANDLES);
      Object.entries(sections).forEach(([handle, html]) => replaceSection(handle, html));
      return true;
    } catch (e) {
      console.warn('Hard refresh failed', e);
      return false;
    }
  }

  document.addEventListener('click', async (e) => {
    const pill = e.target.closest('.variant-pill');
    if (!pill) return;

    const variantId = pill.getAttribute('data-variant-id');
    if (!variantId) return;

    e.preventDefault();
    setBusy(pill, true);

    try {
      const json = await addToCart(variantId, 1);

      // 1) Try to refresh from add.js response
      let refreshed = await refreshFromAddResponse(json);

      // 2) Fallback: fetch the header section directly
      if (!refreshed) refreshed = await hardRefresh();

      // 3) Let theme scripts react
      dispatchCartEvents();

      // 4) Show inline confirmation on the pill itself
      markPillAdded(pill);

      // Minimal toast in case drawer isn’t visible
      if (!document.querySelector('.cart-drawer__dialog[open], .cart-drawer.is-open')) {
        toast('Added to cart');
      }
    } catch (err) {
      console.error(err);
      toast('Could not add to cart');
    } finally {
      setBusy(pill, false);
    }
  });
})();
